import projection from '../generated/pwj203f1.json'; import { AcceptanceManifest } from '../types';
export const pwj203f1AcceptanceManifest = projection as AcceptanceManifest;
